export default {
  token_auth_pi_auth0_login: '/token_auth/pi_auth0_login',
  terms_of_service: 'https://www.predictiveindex.com/terms/',
  privacy_policy: 'https://www.predictiveindex.com/privacy/',
  contact_us: 'https://www.predictiveindex.com/learn/support/#support-case',
  learn_more_about_ba: 'https://www.predictiveindex.com/learn/basics/',
  learn_more_about_taking_ba:
    'https://perform-support.predictiveindex.com/en/articles/8909117-adding-behavioral-insights-to-pi-perform',
  learn_more_about_inspire: 'https://www.predictiveindex.com/learn/basics/#inspire-tab',
  perform_support_article:
    'https://docs.predictiveindex.com/perform/overview/getting-started-with-perform/?utm_content=only_perform',
  relationship_resolve_conflict: 'https://www.predictiveindex.com/learn/support/inspire/conflict/',
  performance_reviews_cycle_documentation:
    'https://docs.predictiveindex.com/perform/admin-guide-perform/review-cycles/initiating-a-review-cycle',
  performance_reviews_cycle_documentation_classic:
    'https://docs.predictiveindex.com/perform/admin-guide-perform/review-cycles/launching-a-review-cycle',
  performance_reviews_preparing_employee_data_documentation:
    'https://docs.predictiveindex.com/perform/admin-guide-perform/review-cycles/preparing-employee-data/',
  pi_admin_employee_directory: 'https://app.predictiveindex.com/pi/admin/users/employee-directory',
  pi_admin_employee_directory_path: '/pi/admin/users/employee-directory',
  pi_2_admin_employee_dirextory_documentation_link:
    'https://docs.predictiveindex.com/admin-guide/user-management/employee-directory/',
};
